import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useIntl } from "react-intl";

import { studentKinds } from "SCConstants";
import CompactNumberInput from "components/CompactNumberInput";
import { getLevelKindEnrolment } from "helpers/enrolment";

import styles from "./attendance-edit.module.scss";

type EnrolmentData = {
  rows?: { level: string; [key: string]: unknown }[];
};

type AttendanceInputCellsProps = {
  level: string;
  shift: string;
  defaultValues: { levels: { level: string; shift: string }[] };
  enrolmentData?: EnrolmentData;
};

const AttendanceInputCells: React.ComponentType<AttendanceInputCellsProps> = ({
  level,
  shift,
  defaultValues,
  enrolmentData,
}) => {
  const intl = useIntl();
  const { watch } = useFormContext();
  const levels_i = defaultValues.levels.findIndex(
    (attendanceLevel) =>
      attendanceLevel.level === level && attendanceLevel.shift === shift
  );

  const enrolmentHintTitle = intl.formatMessage({
    id: "AttendanceEdit.enrolmentHintTitle",
    defaultMessage: "Enrolment",
  });

  return (
    <>
      {studentKinds.map((kind, i) => {
        const key = `levels[${levels_i}].${kind.value}`;
        const max = getLevelKindEnrolment(enrolmentData, level, kind.value);
        const currentValue = parseInt(watch(key)) || 0;
        const isOver = max !== undefined && currentValue > max;
        return (
          <td key={i} className={styles.inputCell}>
            <div className={styles.inputCellInner}>
              {max !== undefined && (
                <div
                  className={`${styles.enrolmentHint} ${
                    isOver ? styles.enrolmentHintOver : ""
                  }`}
                  title={enrolmentHintTitle}
                >
                  {max}
                </div>
              )}
              <Controller
                as={<CompactNumberInput />}
                hideLabel={true}
                placeholder="0"
                min={0}
                max={10000}
                className={isOver ? styles.inputOver : undefined}
                name={key}
                key={key}
              />
            </div>
          </td>
        );
      })}
    </>
  );
};

export default AttendanceInputCells;
